

const getAmount = (amount) => {
    if(amount && amount.length) {
        return amount.slice(0, amount.length - 2)
    }
    return 0; 
}

const getFloatAmount = (amount) => {
    
    if(amount && amount > 0) {
        const amountValue = String(amount);
        return amountValue.substring(0,amountValue.length-2)+'.'+ amountValue.substring(amountValue.length-2);
    }
    return 0;
    
}

export default getAmount;
export {getFloatAmount};